import { createFileRoute } from '@tanstack/react-router'
import { PersonalDataPage } from '@/pages/PersonalDataPage'
import { ROUTES } from '@/constants/routeConstants.ts'

const PersonalData = () => {
  return <PersonalDataPage />
}

export const Route = createFileRoute(ROUTES.PERSONAL_DATA)({
  component: PersonalData,
})
